import React, { FunctionComponent } from 'react'
import './styles.scss'
import TSConstants from '../../utils/TSConstants'
import Wave from '../../app/16_GiftMachine/svg/Wave'
import LotteryConfigurationResponse from '@tootsweet/model/lottery/LotteryConfigurationResponse'
import chroma from 'chroma-js'

interface Props {
  gameBottomText: string
  lotteryConfig?: LotteryConfigurationResponse
}

const BottomWave: FunctionComponent<Props> = (props) => {
  let waveColor = props.lotteryConfig?.colFooterBack || undefined

  if (
    waveColor &&
    props.lotteryConfig?.colFooterBack &&
    props.lotteryConfig?.colBodyBack &&
    props.lotteryConfig?.colBodyBack === props.lotteryConfig?.colFooterBack
  ) {
    waveColor = chroma(waveColor).brighten(1).hex()

    if (waveColor === '#FFFFFF') {
      waveColor = chroma(waveColor).darken(1).hex()
    }
  }
  return (
    <>
      <div className="k-glm-game-bottom">
        <Wave
          position="absolute"
          top={0}
          bottom={0}
          left={0}
          right={0}
          zIndex={1}
          color={waveColor}
        />
        <div className="k-glm-game-bottom-text-container">
          <span
            className="k-glm-game-bottom-text"
            style={{
              color: props.lotteryConfig?.colFooterFont || undefined,
            }}
          >
            1{' '}
            <img
              className="twic"
              style={{
                display: 'inline',
                height: TSConstants.goldenCloverDimension,
              }}
              data-src={`image:/cdm/kadow/glm/${
                props.lotteryConfig?.mlToken || 'token.png'
              }`}
              alt={'Golden Clover'}
            />{' '}
            = {props.gameBottomText}
          </span>
        </div>
      </div>
    </>
  )
}

export default BottomWave
